import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_proxy_string = (proxyList) => {
  const normalizedList = (proxyList || []).map((item) => {
    if (typeof item !== "string") return item;
    const trimmed = item.trim();
    if (trimmed === "") return trimmed;
    const parts = trimmed.split(",").map((p) => p.trim());
    // normalize to [host,port,account,password,type] — discard any status if present
    const defaults = ["", "", "", "", "SOCKS5"];
    if (parts.length < 5) {
      for (let i = parts.length; i < 5; i++) {
        parts.push(defaults[i]);
      }
    } else {
      if (!parts[4]) parts[4] = "SOCKS5";
    }
    return parts.slice(0, 5).join(",");
  });

  return api.post(`${ApiEndpointConstants.ADDMANYPROXY}`, normalizedList);
};

// Expected per-line CSV: ["host,port,account,password,type"]
